




















import Vue from 'vue'

export default Vue.extend({
  props: {
    items: {
      type: Array as () => Array<MapItem>,
      default: () => []
    }
  },
  
  data() {
    return {
      markers: [] as MapItem[],
      showDetails: {}
    }
  },

  methods: {
    showMarkerDetails(index) {
      this.$set(this.showDetails, index, !this.showDetails[index] || true)
    }
  }
})
